
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'al-content-box',
    template: `
        <div *ngIf="isVisible" class="{{arrowClass}} {{contentBoxBrand}}" [ngClass]="styleClass" [class.al-container]="!isPlaceholder" attr.data-contentbox-type="{{contentBoxType}}">
            <div *ngIf="contentBoxType == 'neutral-with-header'"  class="{{headerBrand}} al-text-align-center al-content-box-header">
                <a *ngIf="headerNavigation" href="javascript:void(0);"  class="{{headerBrand}} al-float-left al-padding-left-1x al-padding-right-1x">
                    <i class="fa fa-2x fa-angle-left"></i>
                </a>
                <h3 class="{{headerBrand}} al-display-inline-block" >{{headerTitle}}</h3>
                <a *ngIf="headerNavigation" href="javascript:void(0);"  class="{{headerBrand}} al-float-right al-padding-left-1x al-padding-right-1x">
                    <i class="fa fa-2x fa-angle-right"></i>
                </a>
            </div>
            <div class="al-container-content">
                <ng-content></ng-content>
                <button *ngIf="isDismissible" type="button" class="al-close-alert" data-dismiss="alert" aria-label="Close" (click)="onDismissContentBox($event)">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        </div>
    `
})

export class AlContentBoxComponent implements OnInit {
    public isVisible = true;
    // Set arrow class with position
    public arrowClass: string;

    // Type of content box like Neutral, Neutral with Arrow, Light, Tertiary, Attention, Placeholder, Placeholder(alert)
    @Input() contentBoxType: string;

    // Brand class
    @Input() contentBoxBrand: string;

    // Has pointer arrow. Provide true if need arrow
    @Input() hasArrow: boolean = false;

    // Set arrow position
    @Input() arrowPosition: string;

    // Set placeholder if needed
    @Input() isPlaceholder: boolean = false;

    // Additional style classes provided by user
    @Input() styleClass: any = '';

    // If content box is dismissible
    @Input() isDismissible = false;

    // headerNavigation
    @Input() headerNavigation = true;

    // Type of headerBrand like primary-header, secondary-header, tertiary-header,neutral?-header,neutral?-light-header,thrive-header
    @Input() headerBrand: string;

    // header Title
    @Input() headerTitle: string;

    // Event passed from parent component
    @Output() contentboxDismissEvent: EventEmitter<any> = new EventEmitter();

    ngOnInit() {
        // Add CSS class to display arrow for content-box if hasArrow = true
        /* istanbul ignore if */
        if (this.hasArrow) {
            if (this.arrowPosition) {
                this.arrowClass = 'arrow-box has-arrow-' + this.arrowPosition;
            }
        }
    }

    /* On click of close icon */
    onDismissContentBox(event) {
        this.isVisible = !this.isVisible;
        if (this.contentboxDismissEvent) {
            this.contentboxDismissEvent.emit();
        }
    }

}
